import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";
import type { INBOX_ERROR_CODES } from "@amtana/inbox-contract";

// What a user reads when the inbox fails (packages/module ADR-001), in English and Spanish.

const EN = {
  threadNotFoundTitle: "This conversation doesn't exist",
  threadNotFoundDescription: "It may have been deleted. Pick another conversation from the list.",
} as const;

const ES: Translation<typeof EN> = {
  threadNotFoundTitle: "Esta conversación no existe",
  threadNotFoundDescription: "Puede que se haya eliminado. Elige otra conversación de la lista.",
};

export const INBOX_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const INBOX_ERROR_COPY = {
  inbox_thread_not_found: {
    title: phrase(INBOX_ERROR_CATALOGS, "threadNotFoundTitle"),
    description: phrase(INBOX_ERROR_CATALOGS, "threadNotFoundDescription"),
  },
} satisfies ErrorCopyFor<typeof INBOX_ERROR_CODES>;
